class Museboard {
  constructor(elems) {
    this.paginators        = [].slice.call(document.getElementsByClassName('reference-paginator'));
    this.refBlocks         = [].slice.call(document.getElementsByClassName('reference-block'));
    this.references        = [].slice.call(document.getElementsByClassName('mb-reference'));
    this.refsToggle         = [].slice.call(document.getElementsByClassName('ref-toggle'));

    this.refsToggle.map((toggle, i) => {
      toggle.addEventListener('click', (e) => {
        let target     = e.target;
        let refsToggle = this.refsToggle[0];
        let refsList   = [].slice.call(document.getElementsByClassName('ref-list-mobile'))[0];

        if (refsList.classList.contains('showing')) {
          return refsList.classList.remove('showing');
        }
        return refsList.classList.add('showing');
      });
    });

    //Pagination
    if (this.paginators.length) {
      this.paginators.map((paginator, i) => {
        paginator.addEventListener('click', (e) => {
          let target       = e.target;
          let targetIndex  = parseInt(target.dataset.refBlockIndex);
          let targetBlock  = document.getElementsByClassName(`ref-block-${targetIndex}`)[0];

          if (target.classList.contains('active') && targetBlock.classList.contains('active')) { return; }

          this.paginators.map((paginator) => removeClassName(paginator, 'active'))
          this.refBlocks.map((block) => removeClassName(block, 'active'));

          target.classList.add('active');
          targetBlock.classList.add('active');
        })
      });
    }

    //Hover On/Off
    this.references.map((ref, i) => {
      ref.addEventListener('mouseenter', (e) => {
        let targetRef     = e.target;
        let refBlockIndex = parseInt(targetRef.parentElement.dataset.refBlockIndex);
        let targetImage   = findTargetImage(targetRef, refBlockIndex);

        if (
            targetImage.classList.contains('active-select') &&
            targetRef.classList.contains('active-select')
          ) { return; }
        this.hoverImageOn(targetImage);
      });

      ref.addEventListener('mouseleave', (e) => {
        let targetRef     = e.target;
        let refBlockIndex = parseInt(targetRef.parentElement.dataset.refBlockIndex);
        let targetImage   = findTargetImage(targetRef, refBlockIndex);

        if (
            targetImage.classList.contains('active-select') &&
            targetRef.classList.contains('active-select')
          ) { return; }
        this.hoverImageOff(targetImage);
      });

      // Click
      ref.addEventListener('click', (e) => {
        let targetRef   = e.currentTarget;
        let refBlockIndex = parseInt(targetRef.parentElement.dataset.refBlockIndex);
        let targetImage = findTargetImage(targetRef, refBlockIndex);

        if (
            targetImage.classList.contains('active-select') &&
            targetRef.classList.contains('active-select')
          ) {
          return this.deselectReference(targetImage, targetRef);
        }

        return this.selectReference(targetImage, targetRef);
      });
    });
  }

  hoverImageOn(img) {
    img.classList.add('active-hover');
  }

  hoverImageOff(img) {
    img.classList.remove('active-hover');
  }

  selectReference(img, ref) {
    ref.classList.add('active-select');
    img.classList.add('active-select');
  }

  deselectReference(img, ref) {
    ref.classList.remove('active-select');
    img.classList.remove('active-select');
  }
}

function findTargetImage(target, index=0) {
  let imgBaseClass = 'ref-img';
  let targetIndex  = target.dataset.refIndex;

  return document.getElementsByClassName(`${imgBaseClass}-${targetIndex}`)[index] || null;
}

function removeClassName(el, className) {
  if (el.classList.contains(className)) {
    return el.classList.remove(className);
  }
  return el;
}

export default Museboard;



// WEBPACK FOOTER //
// ./app/javascript/articles/museboard/index.js